<template>
  <div class="container">
    <div v-if="dataCard" class="gift-card-list-container">
      <span class="store-name">{{storeData.store_display_name}}</span>
      <div class="row-info mt15">
        <span>{{storeData.store_display_address}}</span>
      </div>
      <a :href="`tel:${storeData.store_display_phone}`" class="row-info mt10">
        <span>{{storeData.store_display_phone}}</span>
      </a>
      <a :href="storeData.store_main_url" class="row-info mt10">
        <span>{{storeData.store_main_url}}</span>
      </a>
      <img :src="storeData.logo_url" class="store-logo" />
      <item-card
        v-for="item in dataCard.purchased_items"
        :key="item.id"
        :item="item"
        @onClick="focusBarcode = item.redeem_code"
      />
      <div v-if="focusBarcode != null" class="focus-container" @click="focusBarcode = null">
        <vue-barcode
          :value="focusBarcode"
          class="barcode"
          font="SFProText-Medium, -apple-system"
          fontSize="20px"
          fontOptions="500"
          textMargin="10px"
          width="3"
          height="150"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ItemCard from "./components/ItemCard";
import VueBarcode from "vue-barcode";
export default {
  name: "GiftCardList",
  components: {
    ItemCard,
    VueBarcode
  },
  data() {
    return {
      focusBarcode: null
    };
  },
  computed: {
    ...mapGetters(["dataCard"]),
    storeData() {
      return this.dataCard.store_data;
    }
  },
  created() {
    const code = this.$router.history.current.params.code;
    this.$store.dispatch("giftCardList/getData", code);
  }
};
</script>
<style lang="scss" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding-left: calc(50% - 300px);
  padding-right: calc(50% - 300px);
  position: relative;
  overflow: hidden;
  background-color: #fafafa;
  .gift-card-list-container {
    display: flex;
    flex-direction: column;
    color: #222222;
    padding-left: 70px;
    padding-right: 70px;
    background-image: url("../../assets/bggiftcard.png");
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover; /* Resize the background image to cover the entire container */
    min-height: 100vh;
    .store-name {
      font-size: 24px;
      font-family: "SFProText-Semibold", -apple-system;
      font-weight: 600;
      margin-top: 50px;
      align-self: center;
    }
    .row-info {
      display: flex;
      align-items: center;
      justify-content: center;
      .info-logo {
        height: 18px;
        width: auto;
      }
    }

    .store-logo {
      border-radius: 7.5px;
      background-color: white;
      box-shadow: 0 4px 8px rgba($color: #000000, $alpha: 0.2);
      margin: 50px 0 40px 0;
      align-self: center;
      width: 210px;
      height: auto;
    }

    .focus-container {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba($color: #000000, $alpha: 0.8);
      z-index: 10;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  @media only screen and (max-width: 600px) {
    .gift-card-list-container {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>